import React from "react";
import { Flag, fmtAmt } from "../../lib/tour";

// Auto-claimed passive gains that pop up above a wrestler's avatar when entering the tour.
export function TourClaimPops({ gains, className = "" }) {
  if (!gains) return null;
  const rows = Object.entries(gains).filter(([, v]) => Number(v) > 0);
  if (!rows.length) return null;
  return (
    <div className={`absolute left-1/2 -translate-x-1/2 z-30 flex flex-col items-center gap-0.5 pointer-events-none ${className}`} data-testid="tour-claim-pops">
      {rows.map(([c, v], i) => (
        <div key={c} className="tour-claim-pop flex items-center gap-1 px-2 py-0.5 rounded-full bg-[#0A051A]/90 border border-[#39FF14] whitespace-nowrap font-heading text-xs text-[#39FF14]"
             style={{ animationDelay: `${i * 0.15}s`, boxShadow: "0 0 12px #39FF1488", textShadow: "0 0 6px #39FF14" }}>
          <Flag c={c} className={c in { handshakes: 1, titleshots: 1 } ? "w-3.5 h-3.5" : "w-4 h-3"} />
          +{fmtAmt(c, v)}
        </div>
      ))}
    </div>
  );
}
